import api from './axios';

// Auth token for CNG Configuration Pages API
const CNG_AUTH_TOKEN = '64CPLp3gWRdfPAZ6ijluA3Vk48JyZVCqedYR0R6HWA0c2hSnwF';
const CNG_BASE_URL = 'https://cng-config-pages-api-ethvgxbcbpgcc0dw.australiaeast-01.azurewebsites.net';
// const CNG_BASE_URL = 'http://localhost:8000';
let authTokenCache = null;
let authTokenExpiry = null;

// Function to get authentication token
const getAuthToken = async () => {
  // Check if we have a valid cached token
  if (authTokenCache && authTokenExpiry && new Date() < authTokenExpiry) {
    return authTokenCache;
  }

  try {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("authToken", CNG_AUTH_TOKEN);

    const raw = JSON.stringify({
      "email": "admincng@gmail.com",
      "password": "adminadmin"
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    const response = await fetch(`${CNG_BASE_URL}/api/auth/login`, requestOptions);
    const result = await response.json();

    if (result.token) {
      // Cache the token and set expiry time (e.g., 1 hour)
      authTokenCache = result.token;
      authTokenExpiry = new Date(new Date().getTime() + 60 * 60 * 1000); // 1 hour expiry
      return result.token;
    } else {
      throw new Error('Failed to get auth token');
    }
  } catch (error) {
    console.error('Error getting auth token:', error);
    throw error;
  }
};

// Function to search plan numbers
export const searchPlanNumbers = async (query, includeInactive = false) => {
  try {
    if (!query || query.length < 2) {
      return [];
    }

    const token = await getAuthToken();

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const raw = JSON.stringify({
      "plan_number": query,
      "include_inactive": includeInactive,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    const response = await fetch(`${CNG_BASE_URL}/api/searchPlanNumber`, requestOptions);
    const result = await response.json();

    return result.data || [];
  } catch (error) {
    console.error('Error searching plan numbers:', error);
    return [];
  }
};

// Function to search emails
export const searchEmails = async (query) => {
  try {
    if (!query || query.length < 2) {
      return [];
    }

    const token = await getAuthToken();

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const raw = JSON.stringify({
      "email": query
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    const response = await fetch(`${CNG_BASE_URL}/api/searchEmail`, requestOptions);
    const result = await response.json();

    return result.data || [];
  } catch (error) {
    console.error('Error searching emails:', error);
    return [];
  }
};

// Function to get mailroom configurations
export const getMailroomConfigs = async () => {
  const myHeaders = new Headers();

  const token = await getAuthToken();
  myHeaders.append("Authorization", `Bearer ${token}`);


  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
  };

  try {
    const response = await fetch(`${CNG_BASE_URL}/api/getMailroomConfigs`, requestOptions);
    const result = await response.json();
    console.log(result);
    return result.data || []; // Return the result for further use
  } catch (error) {
    console.error('Error fetching mailroom configurations:', error);
    throw error; // Rethrow the error for handling in the calling function
  }
};

export const getMergeFieldsConfig = async () => {
  const myHeaders = new Headers();

  const token = await getAuthToken();
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
  };

  try {
    const response = await fetch(`${CNG_BASE_URL}/api/getMergeFieldConfigs`, requestOptions);
    const result = await response.json();

    const transformedData = (result.data || []).map(field => ({
      field_name: field.field_code,
      field_label: field.label,
      field_type: field.type,
      placeholder: field.placeholder_text,
      is_required: true
    }));

    return transformedData;
  } catch (error) {
    console.error('Error fetching merge fields configuration:', error);
    throw error;
  }
};

// Function to get excluded signature emails
export const fetchExcludedEmails = async () => {
  try {
    const myHeaders = new Headers();

    const token = await getAuthToken();
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    const response = await fetch(`${CNG_BASE_URL}/api/signature-config/exclude-emails`, requestOptions);
    const result = await response.json();
    
    return result.data || [];
  } catch (error) {
    console.error('Error fetching excluded emails:', error);
    return [];
  }
};

// Function to get mailroom configurations
export const getPlanNumberLots = async (planNumber, databaseName) => {
  const myHeaders = new Headers();

  const token = await getAuthToken();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    "plan_number": planNumber,
    "database_name": databaseName
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`${CNG_BASE_URL}/api/getPlanNumberLots`, requestOptions);
    const result = await response.json();
    console.log(result);
    return result.data || []; // Return the result for further use
  } catch (error) {
    console.error('Error fetching mailroom configurations:', error);
    throw error; // Rethrow the error for handling in the calling function
  }
};

export const fetchFrontInboxes = async (userEmail) => {
  try {
    const response = await api.get('/frontapp/inboxes', {
      params: {
        userEmail: userEmail
      }
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching inboxes from Front API:', error);
    return [];
  }
};

export const fetchFrontChannels = async (userEmail) => {
  try {
    const response = await api.get('/frontapp/channels', {
      params: {
        userEmail: userEmail
      }
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching channels from Front API:', error);
    return [];
  }
};

export const fetchEmailSignatures = async (email) => {
  try {
    const response = await api.get('/frontapp/email-signatures', {
      params: {
        userEmail: email
      }
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching email signatures from FrontApp:', error);
    return [];
  }
};

export const fetchInboxChannels = async (inboxId) => {
  try {
    const response = await api.get('/frontapp/inbox-channels', {
      params: { inboxId }
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching channels for inbox:', error);
    return [];
  }
};

export const fetchTeammateEmails = async () => {
  try {
    const response = await api.get('/frontapp/teammate-emails');
    return response.data || [];
  } catch (error) {
    console.error('Error fetching teammate emails:', error);
    return [];
  }
};

export const fetchRegisterMeetings = async (planNumber, databaseName, includeFinalised = false) => {
  try {
    const response = await api.post('/fetch-register-meetings', {
      planNumber: planNumber,
      databaseName: databaseName,
      includeFinalised: includeFinalised
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching register meetings:', error);
    return [];
  }
};

export const searchProcessStreetWorkflowRuns = async (planNumber) => {
  try {
    const response = await api.post('/search-process-street-workflows', {
      planNumber: planNumber
    });
    return response.data || [];
  } catch (error) {
    console.error('Error searching Process Street workflow runs:', error);
    return [];
  }
};

export const fetchSmataContacts = async (planNumber, databaseName) => {
  try {
    const response = await api.get('/smata/contacts', {
      params: { planNumber, databaseName }
    });
    return response.data?.data || [];
  } catch (error) {
    console.error('Error fetching Smata contacts:', error);
    return [];
  }
};

export const fetchSmataBuildingProfile = async (planNumber, databaseName) => {
  try {
    const response = await api.get('/smata/building-profile', {
      params: { planNumber, databaseName }
    });
    return response.data?.data || null;
  } catch (error) {
    console.error('Error fetching Smata building profile:', error);
    return null;
  }
};

export const getWorkflowRunFormFields = async (workflowRunId) => {
  try {
    const response = await api.get('/get-workflow-run-form-fields', {
      params: {
        workflowRunId: workflowRunId
      }
    });
    return response.data || {};
  } catch (error) {
    console.error('Error fetching workflow run form fields:', error);
    return { status: false, error: error.message };
  }
};

export const getBuildingManagers = async (database) => {
  const myHeaders = new Headers();

  const token = await getAuthToken();
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
  };

  try {
    const url = `${CNG_BASE_URL}/api/getBuildingManagers?database=${encodeURIComponent(database)}`;
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    return result.data || [];
  } catch (error) {
    console.error('Error fetching building managers:', error);
    return [];
  }
};

export default {
  searchPlanNumbers,
  searchEmails,
  getMailroomConfigs,
  getMergeFieldsConfig,
  getPlanNumberLots
}; 